import {
  Box,
  GridContainerWithTitle,
  HorizontalDivider,
  TransparentButton,
  Typography,
  UnstyledHtmlAnchor,
} from '@ttx/design-system';
import React from 'react';

export interface WhyConnectWalletModalProps {
  onClose: () => void;
  onPressButton: () => void;
}

export const WhyConnectWalletModal: React.FC<WhyConnectWalletModalProps> = ({
  onClose,
  onPressButton,
}) => {
  return (
    <GridContainerWithTitle
      title="Why do I need to connect wallet?"
      onModalClose={onClose}
      maxWidth={480}
    >
      <Box padding="lg">
        <Typography textStyle="s" color="textDefault">
          Please ensure your wallet is connected so your NFT can be stored
          somewhere. You&apos;ll then be able to proceed with card payment.
        </Typography>
        <Box pt="five" />
        <Box flexDirection="row" flexWrap="wrap">
          <Typography textStyle="s" color="textDefault">
            Find out more on our{' '}
          </Typography>
          <TransparentButton onPress={() => null}>
            <UnstyledHtmlAnchor
              href="https://ttdocs.gitbook.io/faqs/"
              target="blank"
            >
              <Typography
                textStyle="s"
                color="textDefault"
                textDecoration="underline"
                css={{textUnderlineOffset: '2px'}}
              >
                connect wallet FAQ page
              </Typography>
            </UnstyledHtmlAnchor>
          </TransparentButton>
          <Typography textStyle="s" color="textDefault">
            .
          </Typography>
        </Box>
      </Box>
      <HorizontalDivider />
      <Box padding="s" alignItems="center">
        <TransparentButton onPress={onPressButton}>
          <Typography textStyle="s" color="textDefault">
            Got it
          </Typography>
        </TransparentButton>
      </Box>
    </GridContainerWithTitle>
  );
};
